angular.module("vgresiduos").controller("ActionPlanGridCtrl", [
	"$scope",
	"$state",
	"$rootScope",
	"$q",
	"actionPlanService",
	"httpService",
	function ($scope, $state, $rootScope, $q, actionPlanService, httpService) {
		"use strict";

		// Local variables
		const statusActionPlan = {
			[Vgr.enumerations.actionPlan.Status.Finalized]: $rootScope.labels.FINALIZED,
			[Vgr.enumerations.actionPlan.Status.Created]: $rootScope.labels.ACTIVE,
			[Vgr.enumerations.actionPlan.Status.Pending]: $rootScope.labels.ACTIVE,
			[Vgr.enumerations.actionPlan.Status.Canceled]: $rootScope.labels.CANCELED
		};

		// Scope variables
		$scope.gridOptions = {};
		$scope.filters = {};
		$scope.auditValid = null;
		$scope.loading = false;
		$scope.generalStatus = Vgr.constants.generalStatus;

		// Scope functions
		$scope.reloadActionPlans = loadActionPlans;

		this.$onInit = function () {
			loadGridOptions();
			loadActionPlans();

			$scope.gridOptions.removeNew = true;
		};

		function loadGridOptions() {
			$scope.gridOptions = {
				columnDefinitions: getGridColumns(),
				title: $rootScope.labels.CHECKLIST,
				query: { limit: 100, page: 1 },
				data: [],
				promise: {},
				hasData: false,
				errorLoading: false,
				removeDelete: true,
				removeSearch: true,
				removeNew: true,
				hasPermission: function () {
					return true;
				},
				rowClick: function (item) {
					goToActionPlanEditPage(item.id);
				},
				edit: function (item) {
					goToActionPlanEditPage(item.id);
				}
			};

			$rootScope.contentNavBarGrid = $scope.gridOptions;
		}

		function getGridColumns() {
			return [
				{
					field: "organization.name",
					width: 250,
					displayName: function () {
						return $rootScope.labels.ORGANIZATION;
					}
				},
				{
					field: "creationDate",
					width: 250,
					displayName: function () {
						return $rootScope.labels.CREATED_DATE;
					}
				},
				{
					field: "statusDescription",
					width: 250,
					displayName: function () {
						return $rootScope.labels.STATUS;
					}
				},
				{
					field: "userResponsible.name",
					width: 250,
					displayName: function () {
						return $rootScope.labels.RESPONSIBLE;
					}
				},
				{
					editOptions: getGridActions(),
					width: 100,
					displayName: function () {
						return $rootScope.labels.ACTIONS;
					}
				}
			];
		}

		function getGridActions() {
			return [
				{
					type: "custom",
					icon: "edit",
					label: $rootScope.labels.EDIT,
					disable: function (item) {
						return (
							item.status === Vgr.enumerations.actionPlan.Status.Canceled ||
							item.status === Vgr.enumerations.actionPlan.Status.Finalized
						);
					},
					click: function (item) {
						goToActionPlanEditPage(item.id);
					}
				},
				{
					type: "custom",
					icon: "remove_red_eye",
					disable: function (item) {
						return (
							item.status !== Vgr.enumerations.actionPlan.Status.Canceled &&
							item.status !== Vgr.enumerations.actionPlan.Status.Finalized
						);
					},
					click: function (item) {
						goToActionPlanEditPage(item.id);
					}
				}
			];
		}

		function loadActionPlans() {
			$scope.loading = true;

			const dto = {
				queryParams: {
					status: [Vgr.enumerations.actionPlan.Status.Pending]
				},
				supplierId: $scope.ctrl.supplierId
			};

			const deferred = $q.defer();
			httpService
				.getListFromServiceCore(actionPlanService.listSupplierActionPlans, dto)
				.then(
					function (response) {
						fillActionPlanList(response.list);
						$scope.gridOptions.data = response.list;
						deferred.resolve();
					},
					function () {
						deferred.reject();
					}
				)
				.finally(function () {
					$scope.loading = false;
				});

			$scope.gridOptions.hasData = false;
			$scope.gridOptions.promise = deferred.promise;

			return deferred.promise;
		}

		function fillActionPlanList(actionPlans) {
			for (const actionPlan of actionPlans) {
				actionPlan.creationDate = Vgr.util.dateToString(new Date(actionPlan.creationDate));
				actionPlan.statusDescription = statusActionPlan[actionPlan.status];
			}
		}

		function goToActionPlanEditPage(actionPlanId) {
			$state.go("editSupplierActionPlan", {
				supplierCode: $scope.transporterCode,
				actionPlanId,
				supplierId: $scope.ctrl.supplierId
			});
		}
	}
]);
